/**
 * Service Worker kaydı
 * Production build'de SW'yi register eder.
 */

const isLocalhost = Boolean(
    window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/)
);

export function register() {
    if ("serviceWorker" in navigator) {
        const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
        if (publicUrl.origin !== window.location.origin) return;

        window.addEventListener("load", () => {
            const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

            if (isLocalhost) {
                // Localhost'ta SW'yi kontrol et
                checkValidServiceWorker(swUrl);
                navigator.serviceWorker.ready.then(() => {
                    console.log("[SW] Service worker localhost'ta aktif.");
                });
            } else {
                // Production'da direkt register
                registerValidSW(swUrl);
            }
        });
    }
}

function registerValidSW(swUrl) {
    navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
            registration.onupdatefound = () => {
                const installingWorker = registration.installing;
                if (!installingWorker) return;

                installingWorker.onstatechange = () => {
                    if (installingWorker.state === "installed") {
                        if (navigator.serviceWorker.controller) {
                            console.log("[SW] Yeni içerik mevcut, sayfa yenilenecek.");
                            if (window.confirm("Yeni sürüm mevcut. Sayfayı yenilemek ister misiniz?")) {
                                window.location.reload();
                            }
                        } else {
                            console.log("[SW] İçerik offline kullanım için cache'lendi.");
                        }
                    }
                };
            };
        })
        .catch((error) => {
            console.error("[SW] Kayıt başarısız:", error);
        });
}

function checkValidServiceWorker(swUrl) {
    fetch(swUrl, { headers: { "Service-Worker": "script" } })
        .then((response) => {
            const contentType = response.headers.get("content-type");
            if (response.status === 404 || (contentType && !contentType.includes("javascript"))) {
                navigator.serviceWorker.ready.then((registration) => {
                    registration.unregister().then(() => window.location.reload());
                });
            } else {
                registerValidSW(swUrl);
            }
        })
        .catch(() => {
            console.log("[SW] İnternet bağlantısı yok, offline modda çalışıyor.");
        });
}

export function unregister() {
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker.ready
            .then((registration) => registration.unregister())
            .catch((error) => console.error(error));
    }
}
